export default {
      id: "ic-nav-chevron-left-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-nav-chevron-left-usage",
      toString: function () {
        return this.url;
      }
    }